import { InputSelect } from "#common/input/InputSelect"
import { MESES } from "#core/constants"

const InputDateSaving = ({ label, value, setValue, cantidad = 6 }) => {
	function selectMouthSaving(fecha = new Date()) {
		let year = fecha.getFullYear()
		let mouth = fecha.getMonth() + 1
		let day = fecha.getDate()
		let dayEnd = new Date(year, mouth, 0).getDate()
		let daysChange = 4
		let quincena = false
		let dataSelect = []

		if (day > dayEnd - daysChange) {
			quincena = true
			mouth += 1
		} else if (day < 15 - daysChange) quincena = true

		while (cantidad > 0) {
			if (mouth > 12) {
				mouth -= 12
				year += 1
			}
			let daySelect = 15
			if (!quincena) daySelect = new Date(year, mouth, 0).getDate()

			dataSelect.push({
				fecha: `${year}-${mouth}-${daySelect}`,
				option: `${
					quincena ? "Primera Quincena" : "Segunda Quincena"
				} (${daySelect} de ${MESES[mouth - 1]} de ${year})`,
			})

			if (quincena === false) mouth += 1
			quincena = !quincena
			cantidad -= 1
		}

		return dataSelect
	}

	return (
		<InputSelect
			label={label || "Fecha De Ingreso"}
			data={selectMouthSaving()}
			dataLabel="option"
			dataId="fecha"
			value={value}
			setValue={setValue}
			size="small"
		/>
	)
}
export default InputDateSaving
